import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import MailService from "./MailService";

const initialState = {
    isSuccess: false,
    isError: false,
    isLoading: false,
    errors: null,
};

export const SendNewMail = createAsyncThunk(
    "mail/send",
    async (data, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await MailService.SendNewMail(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);

const MailSlice = createSlice({
    name: "mails",
    initialState,
    reducers: {
        mailReset: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.isLoading = false;
            state.errors = null;
        },
    },
    extraReducers: {
        //SendNewMail Actions
        [SendNewMail.pending]: (state) => {
            state.isLodaing = true;
        },
        [SendNewMail.fulfilled]: (state) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [SendNewMail.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.paylaod;
            console.log(action.payload);
        },
    },
});

export const { mailReset } = MailSlice.actions;
export default MailSlice.reducer;
